import { t } from 'i18next';
import { useLRS } from 'link-redux';
import React, {
  FC,
  MouseEventHandler,
} from 'react';

import { useCurrentActor } from '../../hooks/useCurrentActor';
import { LogOut } from '../../middleware/actions';
import { NavbarItemInterface } from '../Navbar/NavbarItem';

import GroenLinksHeader from './GroenLinksHeader';

const HeaderMain: FC = () => {
  const { actorType, admin, organizer } = useCurrentActor();
  const signedIn = actorType !== 'GuestUser';
  const lrs = useLRS();
  const adminAccess = organizer || admin;

  const handleLogOut: MouseEventHandler = (e) => {
    e.preventDefault();

    lrs.actions.get(LogOut)();
  };

  const primaryItems: NavbarItemInterface[] = [
    {
      icon: 'home',
      label: t('menu.main.home'),
      path: '/',
    },
    {
      icon: 'calendar-check-o',
      label: t('menu.main.events'),
      path: signedIn ? '/static/events' : '/static/start#event',
    },
    {
      icon: 'rocket',
      label: t('menu.main.impact'),
      path: '/static/impact',
    },
  ];

  const secondaryItems = [
    {
      label: t('menu.main.help'),
      path: '/pages/help',
    },
    adminAccess && {
      label: t('menu.main.goToAdmin'),
      path: GLOBALS.adminRoot,
    },
    signedIn && {
      label: t('menu.main.signOut'),
      onClick: handleLogOut,
      path: '/logout',
    },
  ].filter(Boolean) as NavbarItemInterface[];

  return (
    <GroenLinksHeader
      primaryItems={primaryItems}
      secondaryItems={secondaryItems}
    />
  );
};

export default HeaderMain;
